import { z } from "zod";

/**
 * Kept out of the round aggregate so the Spec Grants engine can read it
 * without pulling the whole allocation engine into its graph.
 */
export const speculationFundingTypeSchema = z.enum([
  "expedited-funding",
  "matching-pledge",
]);

export type SpeculationFundingType = z.infer<
  typeof speculationFundingTypeSchema
>;

export const speculationFundingTypeLabels: {
  [type in SpeculationFundingType]: string;
} = {
  "expedited-funding": "Expedited funding",
  "matching-pledge": "Matching Pledge",
};
